<form (submit)="onSubmit()" [formGroup]="claimRequestForm">
  <div class="row align-items-center">
    <div class="col">
      <label for="currency">Tipo de moneda</label>
      <ng-select
        [clearable]="false"
        [items]="currencyOptions"
        bindLabel="label"
        bindValue="id"
        class="form-control"
        formControlName="currency"
        placeholder="Seleccione la moneda"
        >
      </ng-select>
    </div>
    @if (holderHasBankAccount) {
      <div class="col">
        <label for="bankAccount">Cuenta de banco titular</label>
        <ng-select
          [clearable]="false"
          [items]="bankAccountOptions"
          bindLabel="description"
          bindValue="id"
          formControlName="bankAccount"
          class="form-control"
          placeholder="Seleccione el banco"
          >
        </ng-select>
      </div>
    }
    @if (!holderHasBankAccount) {
      <div class="col">
        <button
          type="button"
          class="btn btn-outline-success mt-4"
          (click)="openAddAccountModal()"
          >
          + Agregar cuenta
        </button>
      </div>
    }
  </div>

  <div class="form-floating my-3">
    <input
      #d="ngbDatepicker"
      (click)="d.toggle()"
      [maxDate]="today"
      autocomplete="off"
      class="form-control"
      formControlName="serviceDate"
      name="serviceDate"
      ngbDatepicker
      placeholder="dd/mm/yyyy"
      />
    <label>Fecha del servicio</label>
  </div>

  <div class="form-floating my-3">
    <input
      class="form-control"
      formControlName="serviceReason"
      name="serviceReason"
      placeholder="Motivo del servicio o evento"
      sharedFormInput
      />
    <label>Motivo del servicio o evento</label>
  </div>

  <div>
    <label for="service">Servicio recibido *</label>
    <ng-select
      [class.is-invalid]="
        claimRequestForm.get('service')?.invalid &&
        claimRequestForm.get('service')?.touched
      "
      [clearable]="false"
      [items]="serviceOptions"
      bindLabel="description"
      bindValue="serviceCode"
      class="form-control"
      formControlName="service"
      placeholder="Seleccione el servicio *"
      >
    </ng-select>
    @if (
      claimRequestForm.get('service')?.invalid &&
      claimRequestForm.get('service')?.touched
      ) {
      <div
        class="invalid-feedback d-block"
        >
        Servicio es requerido.
      </div>
    }
  </div>

  <div class="form-floating my-3">
    <input
      (focus)="moveCursorToEnd($event)"
      (keydown)="preventInvalidKeys($event)"
      class="form-control"
      currencyMask
      formControlName="claimedAmount"
      inputmode="decimal"
      placeholder="Monto solicitado"
      sharedFormInput
      type="text"
      />
    <label>Monto solicitado</label>
  </div>

  <div class="form-floating my-3">
    <input
      (keydown)="preventInvalidProviderCharacters($event)"
      class="form-control"
      formControlName="provider"
      placeholder="Prestador de servicios"
      sharedFormInput
      />
    <label>Prestador de servicios</label>
  </div>

  @if (claimRequestForm.get('service')?.value) {
    <div>
      @for (doc of documentTypes; track $index) {
        <div class="mb-3">
          <label class="form-label">
            {{ doc.label }}
            @if (doc.required) {
              <span class="text-danger">*</span>
            }
          </label>
          <file-pond
            [options]="getFilePondOptions(doc.labelIdle)"
            [files]="doc.files"
            (onaddfile)="handleDocumentAdd($event, doc)"
            (onremovefile)="handleDocumentRemove($event, doc)"
            >
          </file-pond>
        </div>
      }
    </div>
  }

  <div class="row">
    <div class="col-12">
      <button
        [disabled]="!holderHasBankAccount"
        class="btn btn-dark bg-colonial border-0 w-100 my-3 btn-lg rounded-3"
        type="submit"
        >
        Enviar solicitud
      </button>
    </div>
  </div>
</form>

<div class="row mt-4">
  <div class="d-flex justify-content-between">
    <button (click)="goBack()" class="btn btn-lg btn-default border">
      Regresar
    </button>
  </div>
</div>
